module.exports = {
  apiUrl: 'https://stg.ncbank.gjd.jp/atm/api/',
  apiInfos: {
    POSITION: {
      method: 'POST',
      path: 'find/position'
    },
    AREA_SEARCH: {
      method: 'POST',
      path: 'find/area_search'
    },
    AREA_INFO: {
      method: 'POST',
      path: 'find/area_info'
    },
    GET_CONTENTS: {
      method: 'POST',
      path: 'find/get_contents'
    },
    CONDITIONS_SEARCH: {
      method: 'POST',
      path: 'action/conditions_search'
    },
    SUGGESTION: {
      method: 'POST',
      path: 'action/suggestion'
    },
    DETAIL: {
      method: 'POST',
      path: 'action/detail'
    }
  }
};